import { render, staticRenderFns } from "./LeadsMatch.vue?vue&type=template&id=8b2a216c"
import script from "./LeadsMatch.vue?vue&type=script&lang=js"
export * from "./LeadsMatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports